export enum ReportType {
  Order = 'order',
  OrderDetail = 'order-detail',
  SoldItems = 'sold-items',
  Closing = 'closing',
  CashierMutation = 'cashier-mutation',
}
